// extracted by mini-css-extract-plugin
module.exports = {"buttonsFooter":"AddPackingSheds_buttonsFooter__38Rhr"};